import React from "react";
import InfoCircleIcon from "../img/InfoCircleIcon";
import "./AlertOFLC.scss";

const AlertOFLC = (props) => {
  const { type, messageStyle } = props;

  const colorResolver = (type) => {
    const types = {
      grey: "#5B616B",
    };
    let color = types[type];
    if (!color) color = "#5B616B";
    return color;
  };

  return (
    <div className={`oflc-alert oflc-alert-${type}`}>
      <div className="oflc-alert-body">
        <div className="oflc-alert-icon">
          <InfoCircleIcon color={colorResolver(type)} />
        </div>
        <p className="usa-alert-text" style={messageStyle}>
          {props.children}
        </p>
      </div>
    </div>
  );
};

export default AlertOFLC;
